/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.PH.Title',
    defaultMessage: 'Public Housing',
  },
  agencyName: {
    id: 'App.ViewProperty.AffordableSetup.Programs.PH.AgencyName',
    defaultMessage: 'Agency Name',
  },
  phaCode: {
    id: 'App.ViewProperty.AffordableSetup.Programs.PH.PHACode',
    defaultMessage: 'PHA Code',
  },
  phProgramType: {
    id: 'App.ViewProperty.AffordableSetup.Programs.PH.PHProgramType',
    defaultMessage: 'Program Type',
  },
  phProjectNumber: {
    id: 'App.ViewProperty.AffordableSetup.Programs.PH.PHProjectNumber',
    defaultMessage: 'Project Number',
  },
  phProjectSuffix: {
    id: 'App.ViewProperty.AffordableSetup.Programs.PH.PHProjectSuffix',
    defaultMessage: 'Project Suffix',
  },
  phMinimumRent: {
    id: 'App.ViewProperty.AffordableSetup.Programs.PH.PHMinimumRent',
    defaultMessage: 'Minimum Rent',
  },
  autoSendToPIC: {
    id: 'App.ViewProperty.AffordableSetup.Programs.PH.AutoSendToPIC',
    defaultMessage: 'Auto-send to PIC',
  },
  autoRolloverIncomeAssetsAndExpenses: {
    id: 'App.ViewProperty.AffordableSetupUpdate.Programs.PH.AutoRolloverIncomeAndAssets',
    defaultMessage: 'Auto-Rollover Income, Assets and Expenses',
  },
  autoRolloverIncomeAssetsAndExpensesDescription: {
    id: 'App.ViewProperty.AffordableSetupUpdate.Programs.PH.AutoRolloverIncomeAssetsAndExpensesDescription',
    defaultMessage:
      "When this feature is activated, each time a new recertification process begins, the data from the last completed recertification will be automatically transferred to the income, asset and expenses forms. You'll need to review and confirm each form before it's marked as 'complete'.",
  },
  on: {
    id: 'App.ViewProperty.AffordableSetup.Programs.PH.autoSendToPIC.on',
    defaultMessage: 'On',
  },
  off: {
    id: 'App.ViewProperty.AffordableSetup.Programs.PH.autoSendToPIC.off',
    defaultMessage: 'Off',
  },
  phaCodeLengthError: {
    id: 'App.ViewProperty.AffordableSetup.Programs.PH.PHACodeLengthError',
    defaultMessage: 'PHA Code must be exactly 5 characters',
  },
});

export default messages;
